<template>
  <div
  class="pt-2"
  >
      <v-menu
        bottom
        left
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            :aria-label="$t('languageSwitcher')"
          >
            <v-icon>mdi-earth</v-icon>
          </v-btn>
        </template>

        <v-list
        v-model="$i18n.locale"
        >
          <v-list-item
            v-for="(item, i) in availableLanguagesViewModel"
            @click="handleChange(item.lang)"
            
            :key="i"
          >
          <!-- @change="$i18n.locale = item.viewCode" -->
            <v-list-item-title>{{ item.desc }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
  </div>
</template>

<script>
export default {


  name: 'LanguageSwitcher',
  
  data() {
    return { 
      langObjects: [
        {
        name: 'Deutsch',
        viewCode: 'de_DE',
        },
        {
        name: 'English (US)',
        viewCode: 'en_US',
        },
        {
        name: 'English (GB)',
        viewCode: 'en_GB',
        },
        {
        name: 'Romanian',
        viewCode: 'ro_RO'
        },
        {
        name: 'Swedish',
        viewCode: 'sv_SE'
        },
        {
        name: 'Czech',
        viewCode: 'cs_CZ'
        },
        {
        name: 'Hungarian',
        viewCode: 'hu_HU'
        },
      ]
    };
},

  methods: {
    handleChange(event) {
      //1. Set new Langugage
      this.$i18n.locale = event

      //2. Set overlay
      this.overlay = true

      // console.log(event)

      //2. GET new JSON
      let queries = this.$route.query.reqId.split('-')
      let querySystem = queries[0]
      let queryReqId = queries[1]
      let postingCompany = this.$route.query.postingCompany
      let queryLanguage = event

        let url = ""
        
        if (process.env.NODE_ENV == "development") {
          url = "http://localhost:8080/oca/data?reqId=" + queryReqId + "&system=" + querySystem + "&lang=" + queryLanguage
            if (postingCompany !== undefined) {
            url = url + "&postingCompany=" + postingCompany
          }
        } 
        else {
          var scheme = window.location.protocol;
          var host = window.location.hostname;
          var port = window.location.port;
          url = scheme + "//" + host + ":" + port + "/oca/data?reqId=" + queryReqId + "&system=" + querySystem + "&lang=" + queryLanguage;
            if (postingCompany !== undefined) {
            url = url + "&postingCompany=" + postingCompany
          }
        }

      console.log(url)
      this.$store.dispatch("getPost", url)

      // this.rerender += 1
    }
  },

  computed: {
    lang: {
      get () { return this.$store.state.language },
      set (value) { 
        this.$store.commit('updateLanguage', value)
        this.$i18n.locale = value
        },
    },
    rerender: {
      get() { return this.$store.state.rerender },
      // set (value) { this.$store.commit('updateRerender', value) }
    },
    overlay: { 
      get () {  return this.$store.state.overlay },
      set() { this.$store.commit('toggleOverlay') }
    },
    availableLanguagesViewModel: {
      get () {  return this.$store.state.availableLanguagesViewModel }
    }
  }
};
</script>
